<template>
  <div class="app-container">
    <div class="data-box">
      <div class="name">证书数据</div>
      <div class="box">
        <div>
          <p>下载证书总数</p>
          <h3>{{ msg.total_count }}</h3>
          <div>
            <p>
              日 <i :class="[type[msg.today_total_arrow]]"></i><span>{{ msg.today_total_point }}</span>
            </p>
            <p>
              周 <i :class="[type[msg.w_total_arrow]]"></i><span>{{ msg.w_total_point }}</span>
            </p>
            <p>
              月 <i :class="[type[msg.m_total_arrow]]"></i><span>{{ msg.m_total_point }}</span>
            </p>
          </div>
        </div>
        <div>
          <p>获得证书用户数</p>
          <h3>{{ msg.total_get }}</h3>
          <div>
            <p>
              日 <i :class="[type[msg.today_get_arrow]]"></i><span>{{ msg.today_get_point }}</span>
            </p>
            <p>
              周 <i :class="[type[msg.w_get_arrow]]"></i><span>{{ msg.w_get_point }}</span>
            </p>
            <p>
              月 <i :class="[type[msg.m_get_arrow]]"></i><span>{{ msg.m_get_point }}</span>
            </p>
          </div>
        </div>
        <div>
          <p>证书类型</p>
          <h3>{{ msg.total_type }}</h3>
          <div>
            <p>
              日 <i :class="[type[msg.today_type_arrow]]"></i><span>{{ msg.today_type_point }}</span>
            </p>
            <p>
              周 <i :class="[type[msg.w_type_arrow]]"></i><span>{{ msg.w_type_point }}</span>
            </p>
            <p>
              月 <i :class="[type[msg.m_type_arrow]]"></i><span>{{ msg.m_type_point }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div>
      <h3 class="title">证书类型占比图</h3>
      <div class="search-bar flex">
        <el-date-picker
          v-model="value1"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="changeTime2"
        >
        </el-date-picker>
      </div>
      <div ref="chart" v-loading="loading2" class="chart"></div>
    </div>
  </div>
</template>

<script>
import { mixin } from "@/mixins/pagination.js";
import { certificateList, certificateLine } from "@/api/analysis.js";
export default {
  mixins: [mixin],
  data() {
    return {
      msg: {},
      value1: [],
      loading2: false,
      searchParam: {
        keyword: "",
      },
      type: { 1: "el-icon-top", 0: "", "-1": "el-icon-bottom" },
      charts: null,
      tableData: [{}],
    };
  },
  mounted() {
    this.getList();
    this.getLine();
    this.charts = this.$echarts.init(this.$refs.chart);
  },
  methods: {
    changeTime2(val) {
      if (val) {
        this.searchParam = { ...this.searchParam, start_time: val[0], end_time: val[1] };
      } else {
        this.searchParam = { ...this.searchParam, start_time: "", end_time: "" };
      }
      this.getLine();
    },
    createOption(res) {
      const option = {
        // title: {
        //     text: 'Referer of a Website',
        //     subtext: 'Fake Data',
        //     left: 'center'
        // },
        tooltip: {
          trigger: "item",
          formatter: (val) => {
            console.log(val);
            return "证书名称：" + val.name + "<br/>相关标签数量：" + val.value + "<br/>占比：" + val.percent + "%";
          },
        },
        legend: {
          orient: "vertical",
          right: "right",
          bottom: "center",
        },
        series: [
          {
            name: "证书类型占比",
            type: "pie",
            radius: "50%",
            center: ["25%", "50%"],
            data: res,
            label: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      return option;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/watch-live",
        query: row,
      });
    },
    toData(row) {
      this.$router.push({
        path: "/live-data",
        query: row,
      });
    },

    banItem() {
      this.$confirm("确定要删除该直播吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getLine() {
      const param = {
        ...this.searchParam,
      };
      console.log(param);
      this.loading2 = true;
      const res = await certificateLine(param);
      this.loading2 = false;
      if (res instanceof Array) {
        this.charts.setOption(this.createOption(res), true);
      }
    },
    async getList() {
      const param = {
        // ...this.param1
      };
      console.log(param);
      this.loading = true;
      const res = await certificateList(param);
      this.loading = false;
      if (res) {
        this.msg = res;
      }

      console.log(res);
    },
  },
};
</script>

<style lang="less" scoped="scoped">
.el-icon-bottom {
  color: red;
}
.el-icon-top {
  color: green;
}
.data-box {
  border: 1px solid #eee;
  margin: 20px 0;
  width: 75%;
  .name {
    background-color: #f5f5f5;
    line-height: 35px;
    padding: 10px;
  }
  .box {
    display: flex;
    text-align: center;
    padding: 20px;
    p {
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        width: 15%;
        text-align: right;
        font-weight: 900;
      }
      span {
        // flex: 1;
        width: 20%;
      }
    }
    h3 {
      line-height: 65px;
      font-size: 40px;
    }
    & > div {
      width: 33%;
      border-right: 1px solid #f5f5f5;
      &:last-child {
        border: none;
      }
    }
  }
}

.title {
  line-height: 40px;
  margin-top: 20px;
}

.chart {
  height: 400px;
  width: 50%;
}
</style>
